const httpPrefix = location.hostname === 'localhost'
  ? 'http://localhost:7001'
  : '';


export const handleAPI = (apiObj) => {
   for(let key in apiObj) {
     apiObj[key] = `${httpPrefix}${apiObj[key]}`;
   }
   return apiObj;
}